import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { CenterFrameLayout } from 'Layouts';
import { StaticLinkButton, LinkSubmitButton } from 'Components/Fields/Buttons';
import { logger } from 'Utils/Logger';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { isDefaultPlanFlow } from 'Utils/Analytics/Amplitude';
import './CurrentSubscriber.css';

export const CurrentSubscriberComponent = ({ firstName, email, rootDomain, routes, isDeviceActivation }) => {
  const returnTo = isDefaultPlanFlow() ? routes.signupCreateAccount : routes.signupPlans;
  const logoutLinkWithReturn = `${routes.signout}?return_to=${returnTo}`;

  useEffect(() => {
    logger.started('current subscriber');
  }, []);

  useEffect(() => {
    if (isDeviceActivation) {
      trackEvent(TRACKING_ENUMS.EVENT_PROFILE_ACCESS_ACTIVATION_COMPLETED, {
        page_start_source: 'general',
      });
    }
  }, [isDeviceActivation]);

  return (
    <CenterFrameLayout
      privacyMaskTitle
      title={`Looks like you already have a subscription ${firstName || email || ''}`}
      showLoader={false}
      customClass="currentSubscriber"
    >
      <div className="currentSubscriberContainer">
        <LinkSubmitButton path={logoutLinkWithReturn} text="Use a different email" />
        <br />
        <StaticLinkButton path={rootDomain} text="Continue Watching" className="continueWatching" />
        <br />
      </div>
    </CenterFrameLayout>
  );
};

const mapStateToProps = ({
  user: { firstName, email },
  appConfig: { routes, defaultConfig },
  secondScreen: { isDeviceActivation },
}) => ({
  firstName,
  email,
  rootDomain: defaultConfig.rootDomain,
  routes,
  isDeviceActivation,
});

export const CurrentSubscriberContainer = connect(mapStateToProps)(CurrentSubscriberComponent);
